import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Comments from '@src/mobile/components/Comments';
import styles from './index.css';

const CommentModal = ({ close, subjectId, replyId, allowComment }) => {
    return (
        <div className={styles.wrap}>
            <div className={styles.nav}>
                <div className={styles.title}>热门评论</div>
                <div
                    className={styles.close}
                    onClick={() => {
                        close();
                    }}
                    onTouchStart={e => {
                        e.stopPropagation();
                    }}
                    onTouchMove={e => {
                        e.stopPropagation();
                    }}
                    onTouchEnd={e => {
                        e.stopPropagation();
                    }}
                />
            </div>
            <div className={styles.comment}>
                <Comments subjectId={subjectId} replyId={replyId} allowComment={allowComment} />
            </div>
        </div>
    );
};

CommentModal.propTypes = {
    close: PropTypes.func,
    subjectId: PropTypes.string,
    replyId: PropTypes.string,
    allowComment: PropTypes.bool,
};

export default errorBoundary(CommentModal);
